export default __webpack_public_path__ + "static/Pattern4-af0af54f64459b1b8606fd0c73325886.png";